module.exports = __webpack_public_path__ + "img/sx.9ad82f83.svg";